import React, { useState } from "react";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import { UxAction, UxIconEnum, UxSizeEnum, UxPriorityEnum, UxStyleEnum, useSpeechStream } from "@imaginelearning/mps-ux-component-library";
function TextToSpeechToolbar(props) {
    var timer;
    var showToolbar = props.showToolbar, reset = props.reset, isSpanishContent = props.isSpanishContent;
    var _a = useState({ showPlay: true }), playState = _a[0], setPlayState = _a[1];
    var _b = useSpeechStream(isSpanishContent), isAvailable = _b.isAvailable, play = _b.play, pause = _b.pause, stop = _b.stop, isSpeaking = _b.isSpeaking, isPlaying = _b.isPlaying;
    if (reset && !playState.showPlay) {
        setPlayState({ showPlay: true });
    }
    var handlePlayPause = function () {
        var showPlay = playState.showPlay;
        if (showPlay) {
            play("content-reader");
            setPlayState({ showPlay: !showPlay });
            checkHasReachedEnd();
        }
        else {
            pause();
            setPlayState({ showPlay: !showPlay });
        }
    };
    var handleStop = function () {
        stop();
        setPlayState({ showPlay: true });
    };
    var checkHasReachedEnd = function () {
        if (timer) {
            clearInterval(timer);
        }
        timer = setInterval(function () {
            if (!isSpeaking()) {
                setPlayState({ showPlay: true });
                clearInterval(timer);
            }
        }, 1000);
    };
    return (showToolbar && (React.createElement(ButtonToolbar, { className: "tts-toolbar" },
        React.createElement(UxAction, { enabled: isAvailable, priority: UxPriorityEnum.INFO, callback: handlePlayPause, style: UxStyleEnum.BOXED, className: "play-toolbar", "aria-expanded": playState.showPlay ? "false" : "true", icon: {
                title: "Play",
                icon: playState.showPlay ? UxIconEnum.PLAY : UxIconEnum.PAUSE,
                size: UxSizeEnum.LARGE
            } }),
        React.createElement(UxAction, { enabled: isAvailable && isPlaying, priority: UxPriorityEnum.INFO, callback: handleStop, style: UxStyleEnum.BOXED, className: "stop-toolbar", icon: {
                title: "Stop",
                icon: UxIconEnum.STOP,
                size: UxSizeEnum.LARGE
            } }))));
}
export default TextToSpeechToolbar;
